import { render, staticRenderFns } from "./CourseIntroduce.vue?vue&type=template&id=50a88e66&scoped=true&"
import script from "./CourseIntroduce.vue?vue&type=script&lang=js&"
export * from "./CourseIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./CourseIntroduce.vue?vue&type=style&index=0&id=50a88e66&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a88e66",
  null
  
)

export default component.exports